import { createPopper } from '@popperjs/core/lib/popper-lite.js';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow.js';
import flip from '@popperjs/core/lib/modifiers/flip.js';
import arrow from '@popperjs/core/lib/modifiers/arrow.js';
import offset from '@popperjs/core/lib/modifiers/offset.js';

import {escapeHTML} from '@massimo-cassandro/m-utilities/js-utilities/escapeHTML';
import {print_icon} from '@massimo-cassandro/m-utilities/boilerplate-twig-src/print-icon';
import {img_viewer} from '@massimo-cassandro/m-utilities/boilerplate-twig-src/imgs-viewer';
import app_data from '../../js/globali/get-app-data';

const infobox_class = 'brk-player-info-box',
  visible_infobox_selector = `.${infobox_class}:not([data-popper-reference-hidden])`;

let popperInstances = {};

function remove_player_path() {
  document.querySelector('.brk-wrapper')?.classList.remove('brk-paths');

  document.querySelectorAll('.brk-match-path').forEach(item => {
    item.classList.remove('brk-match-path');
  });
  document.querySelectorAll('.brk-player-path').forEach(item => {
    item.classList.remove('brk-player-path');
  });
}

function player_path(player_id) {
  remove_player_path();
  document.querySelectorAll(`.brk-match-wrapper[data-p~="${player_id}"]`).forEach(item => {
    item.classList.add('brk-match-path');
    item.querySelector(`.brk-match-player[data-pid="${player_id}"]`)?.classList.add('brk-player-path');
  });
  document.querySelector('.brk-wrapper')?.classList.add('brk-paths');
}

export function close_infobox() {
  const active_infobox = document.querySelector(visible_infobox_selector);
  if(active_infobox) {
    active_infobox.setAttribute('data-popper-reference-hidden', true);
  }
  remove_player_path();
}


// listeners da applicare globalmente
export function info_popup_listeners() {

  document.body.addEventListener('click', e => {

    let closest_info_popup_box = e.target.closest(`.${infobox_class}`);

    // player-info close btns
    if(e.target.classList.contains('btn-close') && closest_info_popup_box) {
      close_infobox();
    }

    // clic outside
    let active_infobox = document.querySelector(visible_infobox_selector),

      // brk-has-cbk è gestito dallo script di generazione dei bracket
      is_infobox_trigger = e.target.classList.contains('brk-has-cbk') || e.target.closest('.brk-has-cbk');

    if(active_infobox) {
      if (e.target !== active_infobox && !closest_info_popup_box && !is_infobox_trigger) {
        close_infobox();
      }
    }

  }, false);

  // esc key
  document.body.addEventListener('keydown', function(e) {
    if(e.key === 'Escape') {
      close_infobox();
    }
  }, true);

}

// finestra info player
export default function (player_element, is_team) {

  if(window.process === undefined) {
    window.process = { env: { NODE_ENV: 'production' } }; // safari non supporta l'operatore ??=
  }

  const player_id       = player_element.dataset.pid,
    json_url            = app_data.baseUrl + (is_team? '/info-team/' : '/info-player/') + player_id,

    // selettore del div usato per l'info-box
    info_box_selector   = `.${infobox_class}[data-pid="${player_id}"]`,

    fallback_img        = print_icon('logo', 'brk-fbk-img', app_data.icons),
    badge_dir           = '/imgs/badge/',
    medals_dir          = '/imgs/premi/';

  close_infobox(); // chiude eventuale infobox aperti

  let info_popup_box = document.querySelector(info_box_selector);

  if(info_popup_box) { // se esiste già viene mostrato direttamente
    info_popup_box.removeAttribute('data-popper-reference-hidden');

    // aggiorna l'elemento reference nel caso la stessa infobox
    // sia chiamata da più posizione del bracket
    popperInstances[player_id].state.elements.reference = player_element;
    popperInstances[player_id].update();

    player_path(player_id);

  } else {
    player_element.insertAdjacentHTML('beforeend',
      `<div class="brk-overlay text-center">
        <div class="text-white spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>`
    );

    (async () => {
      const response = await fetch(json_url);
      if (!response.ok) {
        /* eslint-disable */
        console.error('Ajax error on: ' + json_url);
        console.error(response);
        /* eslint-enable */
        throw `Si è verificato un errore nell'acquisizione dei dati: ${response.status}`;
      }
      const data = await response.json();
      return data;
    })()
      .then(data => {
        if(data) {
          /*
          giocatori singoli:
          ---------------------
          {
            "id": 100,
            "slug": null,
            "nickname": "akias100",
            "crYear": 2020,
            "foto": {
              "id": 227,
              "width": 1600,
              "height": 1511,
              "mime": "image/jpeg",
              "size": 81385
            },
            "badge": {
              "id": 3,
              "badge": "Gold",
              "icona": "badge-gold"
            },
            "medaglie": [
              {
                "torneo": "FIFA Summer Night! - 30 Luglio ore 19:00",
                "data": "2020-07-30",
                "medaglia": {
                  "nome": "Secondo classificato",
                  "icona": "premi-secondo.svg"
                }
              },
              ...
            ]
          }


          teams:
          ----------------------
          {
            "id": 5,
            "slug": "akias-squad",
            "nome": "Akias Squad",
            "crYear": 2022,
            "foto": null o {...},
            "medaglie": [] <-- come giocatori singoli
          }
          */

          let img = '';
          if(data.foto ) {

            img = img_viewer({
              viewer: '/viewer',
              img: data.foto,
              bbs: [
                {mq: null, bb: [80,80]}
              ],
              lazy: false,
              viewer_params: 'fd=1', // eventuali parametri aggiunti per il viewer
              // img_fmt: [], // array dei formati di immagine prodotti dal viewer
              alt: data.nickname,
              class: '',
              async: true,
              fw: 'bs5'
            });

          } else { // immagine fallback
            img = fallback_img;
          }

          let badge = '';
          if(!is_team && data.badge !== null) {
            badge = `<div class="brk-pi-badge">
              <img src="${badge_dir}${data.badge.icona}.svg" alt="${escapeHTML(data.badge.badge)}">
            </div>`;
          }

          if(data.medaglie === undefined || data.medaglie === null) {
            data.medaglie = [];
          }

          /* eslint-disable indent*/
          document.body.insertAdjacentHTML('beforeend',
            `<section class="${infobox_class}" role="tooltip" data-pid="${player_id}">
              <button type="button" class="btn-close" aria-label="Chiudi"></button>
              <div class="brk-pi-head">
                <div class="brk-pi-img-wrapper">
                  <div class="brk-pi-img">${img}</div>
                  ${badge}
                </div>
                <div class="brk-pi-nick">
                  <h1>${is_team? data.nome : data.nickname}</h1>
                  ${(data.idConsole && data.idConsole.toLowerCase() !== data.nickname.toLowerCase())?
                    `<p>Id gioco: <strong>${data.idConsole}</strong></p>` : ''}
                  <p>In Esports Academy dal ${data.crYear}</p>
                </div>
              </div>
              ${data.medaglie.length?
                `<div class="pi-medaglie-wrapper">
                  ${data.medaglie.map(medal => {
                    return `<div class="brk-pi-medaglia">
                      <div>
                        <img src="${medals_dir}${medal.medaglia.icona}" alt="${escapeHTML(medal.medaglia.nome)}">
                      </div>
                      <div>
                        <p class="brk-pi-medaglia-torneo">${medal.torneo}</p>
                        <p class="brk-pi-medaglia-data">${new Date(medal.data).toLocaleString('it-IT', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}</p>
                      </div>
                    </div>`;
                  }).join('')}
                </div>`
              : ''}
              <div class="brk-pi-url">
                <a href="${is_team? `/team/${data.slug}` : `/presentazione/${player_id}`}">Vai al profilo completo</a>
              </div>
              <div class="brk-pi-arrow" data-popper-arrow></div>
            </section>`
          );
          /* eslint-enable indent*/

          player_element.querySelector('.brk-overlay').remove();

          info_popup_box = document.querySelector(info_box_selector);

          popperInstances[player_id] = createPopper(player_element, info_popup_box, {
            modifiers: [
              flip,
              preventOverflow,
              arrow,
              offset,
              {
                name: 'offset',
                options: {
                  offset: [20, 20],
                }
              }
            ]
          });
          player_path(player_id);

        } else {
          throw 'Si è verificato un errore (no-data)';
        }
      })
      .catch(error => {
        alert(error);
      });

  } // end if info_popup_box
}
